import { render, staticRenderFns } from "./planSearch.vue?vue&type=template&id=13ddb8f5&scoped=true&"
import script from "./planSearch.vue?vue&type=script&lang=ts&"
export * from "./planSearch.vue?vue&type=script&lang=ts&"
import style0 from "./planSearch.vue?vue&type=style&index=0&id=13ddb8f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ddb8f5",
  null
  
)

export default component.exports